import React from 'react';
import { Collapse} from 'antd';
import BasicMsg from '../messages/BasicMsg';
import GhostTxt from '../texts/GhostTxt';
import ClassroomsContainer from './ClassroomsContainer';

import * as UsersActions from '../../redux/actions/UsersActions'

import { connect } from 'react-redux';

import './styles/CoursesContainer.css'

const { Panel } = Collapse;

class CoursesContainer extends React.Component{
    state={ 
    
    }
    UNSAFE_componentWillMount(){
        if(this.props.idUserType === 3){
            if(this.props.courses === null){
                this.props.getStudentCoursesRequest({
                    userId:this.props.UsersReducer.userToShow.idUsuario,
                    jwtToken: this.props.LoginReducer.sessionJWTToken
                })
            }
        }
    }

    render(){
        let courses = this.props.courses
        return(
            <div className='courses-container'>    
                {
                    (!courses || courses.length === 0) 
                    ?   <BasicMsg message='Por el momento no hay cursos asignados.'/>
                    :   <div>
                        <h3 style={{ marginBottom:'15px', marginTop:'15px' }}>CURSOS ASIGNADOS</h3>
                        {courses.map((course, id) => ( 
                            <Collapse expandIconPosition={'right'} defaultActiveKey={null} style={{backgroundColor:course.etiqueta, width:'100%', borderRadius:'8px', boxShadow:'3px 4px 4px -1px rgba(0, 0, 0, 0.5)', marginBottom:'25px'}} >
                                <Panel 
                                    key={id}
                                    header={
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <div
                                                style={{
                                                    width: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                <GhostTxt text={course.nombre.toUpperCase()} className='name-tag'/>
                                            </div>
                                        </div>
                                    }
                                >
                                    
                                    <ClassroomsContainer 
                                        view={this.props.view}

                                        course = {course}
                
                                        idUserType={this.props.idUserType} 
                                        idUser={this.props.idUser}
                                        studentLimitHrs ={this.props.studentLimitHrs}
                                        userEnable = {this.props.userEnable}
                                    />
                                                            
                                </Panel>
                            </Collapse>
                        ))}
                        </div>
                }
            </div>
        )
    }
}

const mapStateToProps=(state)=>{
    return state
}
const mapDispatchToProps = {
    ...UsersActions
};
export default connect (mapStateToProps,mapDispatchToProps)(CoursesContainer);